import { setHouseId } from '@cian/valuation-main-filters-widget';
import { BadRequestError } from '@cian/valuation-utils-component';

import {
  fetchValidateAddressWeb,
  IValidateAddressWebResponse200 as IRes200,
  IValidateAddressWebResponse400 as IRes400,
} from '../../repositories/price-estimator/v1/validate-address-web';
import { TThunkAction } from '../../types/redux';

/**
 * Санк для валидации адреса и сохранения получившегося houseId в стор
 * Необходимо вызвать его на стороне node заранее ДО запроса за Похожими офферами
 * Т.к апи Похожих офферов требует realtyId (=houseId)
 * */
export const validateAddress = (): TThunkAction<Promise<number | Error>> => async (dispatch, getState, context) => {
  const {
    filters: { address },
  } = getState();

  try {
    const res = await fetchValidateAddressWeb<IRes200, IRes400>({
      httpApi: context.httpApi,
      parameters: { address },
    });

    if (res.statusCode !== 200) {
      throw new BadRequestError({
        domain: 'validateAddress.ts',
        message: res.response.message as string,
        details: { errors: JSON.stringify(res.response.errors) },
      });
    }

    dispatch(setHouseId({ houseId: res.response.houseId }));

    return res.response.houseId;
  } catch (e) {
    if (!(e instanceof BadRequestError)) {
      context.logger.error(e, { message: 'Unable to validate address' });
    } else {
      context.logger.debug('validateAddress: bad request', { message: e.message, domain: e.domain });
    }

    return e as Error;
  }
};
